import { QueryClient } from '@tanstack/react-query'
import { INotificationContentHandler } from '@/lib/handler/notification-content-handler'
import { NotificationType } from '@/types/notification'
import { DashboardResponseType } from '@/types/dashboard'

/**
 * Orders Content Handler
 * When a new order notification arrives via WebSocket:
 * - Increments dashboard `orders.total` and `orders.pending` counters
 * - Invalidates the orders list if it's currently active (page is open)
 */
export default class OrdersContentHandler implements INotificationContentHandler {
  handle(_notification: NotificationType, queryClient: QueryClient): void {
    queryClient.setQueryData<DashboardResponseType>(['dashboard'], old => {
      if (!old?.stats) {
        return old
      }
      const currentOrders = old.stats.orders
      return {
        ...old,
        stats: {
          ...old.stats,
          orders: {
            total: (currentOrders?.total ?? 0) + 1,
            pending: (currentOrders?.pending ?? 0) + 1,
            confirmed: currentOrders?.confirmed ?? 0,
            processing: currentOrders?.processing ?? 0,
            shipped: currentOrders?.shipped ?? 0,
            delivered: currentOrders?.delivered ?? 0,
            cancelled: currentOrders?.cancelled ?? 0,
            refunded: currentOrders?.refunded ?? 0
          }
        }
      }
    })

    void queryClient.invalidateQueries({
      queryKey: ['orders'],
      refetchType: 'active'
    })
  }
}
